// extracted by mini-css-extract-plugin
export default {"spinner":"spinner_spinner__du8pg","spinnerInner":"spinner_spinnerInner__V-AVN","rotating":"spinner_rotating__8mAOH"};